import Controller from '@ember/controller';
import { action } from '@ember/object';
import type MarketSettingsCostIndexRoute from 'lumen/routes/market/settings/cost/index';
import type { ModelFrom } from 'lumen/utils/routes';

export default class MarketSettingsCostIndexController extends Controller {
  declare model: ModelFrom<MarketSettingsCostIndexRoute>;

  // TODO: gate on the real cost-settings edit-access flag once it exists.
  get isReadOnly(): boolean {
    return false;
  }

  // `@profiles` is a resolved snapshot, not a live store array, so deleting a
  // row doesn't shrink it — re-run the list task to refresh.
  @action refreshProfiles(): void {
    void this.model.profiles.perform();
  }
}
